(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gift-guide-hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var COLOR_VARS = ['--ggh-bg', '--ggh-text', '--ggh-accent', '--ggh-accent-text'];

    function initSlideshow(root) {
      if (!root || root.dataset.gghReady) return;
      root.dataset.gghReady = 'true';

      var track = root.querySelector('[data-ggh-track]');
      var slides = Array.prototype.slice.call(root.querySelectorAll('[data-ggh-slide]'));
      if (slides.length < 2) return;

      var nav = root.querySelector('[data-ggh-nav]');
      var dots = Array.prototype.slice.call(root.querySelectorAll('[data-ggh-dot]'));
      var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var designMode = window.Shopify && window.Shopify.designMode;
      var current = 0;
      var hoverPaused = false;

      // Autoplay runs only when it is on, outside the theme editor, and without reduced motion.
      // The indicators animate only while autoplay runs.
      var autoplay = parseInt(root.dataset.autoplay, 10) > 0 && !reducedMotion && !designMode;

      function setAutoplay(value) {
        autoplay = value;
        root.classList.toggle('ggh--animated', autoplay);
      }

      function updatePaused() {
        root.classList.toggle('is-paused', hoverPaused);
      }

      // Only the visible slide is reachable by keyboard and screen readers.
      // The indicators take the colors of the active slide.
      function setActive(index) {
        current = index;
        slides.forEach(function (slide, n) {
          slide.inert = n !== index;
        });
        dots.forEach(function (dot, n) {
          dot.classList.remove('is-active');
          if (n === index) {
            dot.setAttribute('aria-current', 'true');
          } else {
            dot.removeAttribute('aria-current');
          }
        });
        if (dots[index]) {
          // A reflow restarts the fill animation.
          void dots[index].offsetWidth;
          dots[index].classList.add('is-active');
        }
        if (nav) {
          var style = getComputedStyle(slides[index]);
          COLOR_VARS.forEach(function (name) {
            nav.style.setProperty(name, style.getPropertyValue(name));
          });
        }
      }

      // The scroll handler ignores positions until a programmatic scroll reaches its target.
      var targetIndex = null;
      var targetTimer = null;

      function goTo(index) {
        index = (index + slides.length) % slides.length;
        targetIndex = index;
        clearTimeout(targetTimer);
        targetTimer = setTimeout(function () {
          targetIndex = null;
        }, 1000);
        track.scrollTo({ left: slides[index].offsetLeft, behavior: reducedMotion ? 'auto' : 'smooth' });
        setActive(index);
      }

      // A swipe or a scroll changes the active slide.
      var scrollTimer = null;
      track.addEventListener('scroll', function () {
        clearTimeout(scrollTimer);
        scrollTimer = setTimeout(function () {
          var index = Math.round(track.scrollLeft / track.clientWidth);
          if (targetIndex !== null) {
            if (index === targetIndex) targetIndex = null;
            return;
          }
          if (index !== current && slides[index]) setActive(index);
        }, 80);
      });

      // Autoplay moves to the next slide when the fill animation of the active indicator ends.
      root.addEventListener('animationend', function (event) {
        if (!autoplay || hoverPaused) return;
        if (!event.target.classList.contains('ggh__dot-fill')) return;
        goTo(current + 1);
      });

      dots.forEach(function (dot, n) {
        dot.addEventListener('click', function () {
          goTo(n);
        });
      });

      root.addEventListener('mouseenter', function () {
        hoverPaused = true;
        updatePaused();
      });
      root.addEventListener('mouseleave', function () {
        hoverPaused = false;
        updatePaused();
      });
      root.addEventListener('focusin', function () {
        hoverPaused = true;
        updatePaused();
      });
      root.addEventListener('focusout', function (event) {
        if (root.contains(event.relatedTarget)) return;
        hoverPaused = false;
        updatePaused();
      });

      root.gghGoTo = function (slide) {
        var index = slides.indexOf(slide);
        if (index > -1) goTo(index);
      };
      root.gghPause = function () {
        setAutoplay(false);
      };

      setAutoplay(autoplay);
      setActive(0);
    }

    function initAll(scope) {
      Array.prototype.forEach.call((scope || document).querySelectorAll('[data-ggh]'), initSlideshow);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        initAll();
      });
    } else {
      initAll();
    }

    // Theme editor events.
    document.addEventListener('shopify:section:load', function (event) {
      initAll(event.target);
    });
    document.addEventListener('shopify:block:select', function (event) {
      var slide = event.target.closest('[data-ggh-slide]');
      var root = slide && slide.closest('[data-ggh]');
      if (root && root.gghGoTo) {
        root.gghPause();
        root.gghGoTo(slide);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
